import { useCallback } from "react";
import useCache from "./useCache";
export default function useCachedFileEntries(cacheKey, initialFiles) {
  var _a = useCache(cacheKey, initialFiles, areFileEntries),
    value = _a[0],
    setValue = _a[1],
    setValueIfNewer = _a[2];
  var setFiles = useCallback(function (newFiles) {
    if (typeof newFiles === "function") {
      newFiles = newFiles(value);
    }
    setValue({
      value: newFiles,
      timestamp: Date.now()
    });
  }, [value, setValue]);
  var setFilesIfNewer = useCallback(function (newFiles) {
    if (value.every(function (x) {
      return x.fullName === "empty.py";
    })) {
      setValue(newFiles);
    } else {
      setValueIfNewer(newFiles);
    }
  }, [setValue, setValueIfNewer, value]);
  return [value, setFiles, setFilesIfNewer];
}
var areFileEntries = function (data) {
  if (!Array.isArray(data)) return false;
  return data.every(function (x) {
    return isFileEntry(x);
  });
};
var isFileEntry = function (data) {
  if (typeof data.content !== "string") return false;
  if (typeof data.fullName !== "string") return false;
  if (data.fullName.length <= 0) return false;
  if (typeof data.originalContent !== "string") return false;
  if (typeof data.shortName !== "string") return false;
  return true;
};